const button = document.querySelector(".btn-load");
const blocks = document.querySelectorAll(".contact-stores .blocks .block");

button.addEventListener("click", function () {
    blocks.forEach(block => block.classList.add("active"));
    button.style.display = "none";
});